import React from 'react'
import PropTypes from 'prop-types'
import {Checkbox, FormControlLabel} from "@material-ui/core";
import {TextValidator} from "react-material-ui-form-validator";
import localization from 'config/localization';
import {userIsTrial} from "../../../../api-client/core/authentication/utils";
import styled from "styled-components";


const FormView = ({
  title,
  subtitle,
  onChange,
  disabled = false,
  onUserLibraryChange,
  onVisibilityLibraryChange,
  userLibrary,
  visibility,
}) => {

  return (
    <div>
      <TextValidator
        style={{ width: "calc(100% - 2em)", minWidth: window.innerWidth > 1000 ? 400 : 0, margin: "0 1em"}}
        id="title"
        label={localization.get('form.title')}
        name="title"
        value={title}
        onChange={onChange}
        disabled={disabled}
        validators={['required']}
        errorMessages={[localization.get('validator.is_required')]}
      />
    </div>
  )
}

FormView.propTypes = {
  onChange: PropTypes.func.isRequired,
  onImageChange: PropTypes.func.isRequired,
  client: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  disableClientInput: PropTypes.bool,
};

export default FormView